module.exports = __webpack_public_path__ + "f0facf613a866602198d1f587c9a2e88.pdf";